// Re-export from the new modular structure
import urlPath from './urlPaths';

export type { PathType } from './urlPaths';
export { getPath } from './urlPaths';

export default urlPath;
